/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TeamPlannerDto } from '../../models/team-planner-dto';

export interface GetTeamPlanner$Params {
  id: string;
}

export function getTeamPlanner(http: HttpClient, rootUrl: string, params: GetTeamPlanner$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamPlannerDto>> {
  const rb = new RequestBuilder(rootUrl, getTeamPlanner.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TeamPlannerDto>;
    })
  );
}

getTeamPlanner.PATH = '/v0/teamPlanners/{id}';
